

import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

const TopCampaigns = (props) => {
  const { data, history } = props;
  return (
    <div>
      <Carousel autoPlay={true} showThumbs={false} interval={5000} infiniteLoop={true} showStatus={false} className="homepage-banner">
        {
          data && data.length && data.map(({ id, cover_photo, story, title }, index) => {
            let firstStorySentence = '';
            let secondStorySentence = '';
            if (story && story.length >= 80) {
              firstStorySentence = `${story.substring(0, 30)}`;
              secondStorySentence = `${story.substring(30, 70)}...`;
            } else if (story && story.length < 80) {
              firstStorySentence = story;
            }
            let coverPhoto = '/images/banner.png';
            if (cover_photo) {
              coverPhoto = `${process.env.REACT_APP_BACKEND_BASE_URL}${cover_photo}`;
            }
            return <div key={index}>
              <section style={{ backgroundImage: `url("${coverPhoto}")` }} className='bannerForCategoryCampaigns'>
                <div className="container">
                  <div className="row  ">
                    <div className="col-lg-6 col-md-12 col-sm-12 banner-text-col">
                      <h1>
                        {title}
                        {/* <span className="d-block"> you care about</span> */}
                      </h1>
                      <p className="">
                        {firstStorySentence}
                        <br></br>
                        {secondStorySentence}
                      </p>
                      <button
                        style={{ float: 'left' }}
                        onClick={() => {
                          history.push({
                            pathname: `/donate-money/${id}`
                          });
                        }}
                        type="button"
                        className="btn btn-outline-light ">
                        Donate now
                        </button>
                      <button style={{ float: 'left' }} onClick={() => history.push('/starting_fund')} type="button" className="btn btn-success  ml-2 btn_hover">Start fundraising</button>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          })
        }
      </Carousel>
    </div>
  );
}

export default TopCampaigns;
